/* eslint-disable import/no-mutable-exports */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable prefer-destructuring */
// eslint-disable-next-line
import { requirejs as requirejsImport, require as requireImport, define as defineImport } from 'exports-loader?requirejs,require,define!requirejs/require';

window.requirejs = window.requirejs || requirejsImport;
window.require = window.require || requireImport;
const originalDefine = window.define || defineImport;
window.define = (...args) => {
  // This is a workaround for chrome extension injecting anonymous define's in our code.
  // If we detect a define call without a name, we give it a random name.
  const name = args[0];

  if (typeof name !== 'string') {
    const randomName = Math.random().toString(36).slice(2, 7);

    return originalDefine(randomName, ...args);
  }
  return originalDefine(...args);
};
window.define.amd = originalDefine.amd;

export var requirejs = window.requirejs;
export var require = window.require;
export var define = window.define;

export default requirejs;
